<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'details' ? 'active' : '']" href @click.prevent="selectedTab = 'details'" id="details-tab" data-toggle="tab" role="tab" aria-controls="details" :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'history' ? 'active' : '']" href @click.prevent="selectedTab = 'history'" id="history-tab" data-toggle="tab" role="tab" aria-controls="history" :aria-selected="selectedTab === 'history' ? 'true' : 'false'">History</a>
    </li>
    <member-profile-details
      :memberDetails="memberDetails"
      @renew="renew"
      v-if="selectedTab === 'details'"
      slot="tabContent"
      class="tab-pane row mx-0 show active"
      d="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <member-profile-history
      v-if="selectedTab === 'history'"
      :memberID="memberDetails.id"
      :membership_options="memberDetails.membership_options"
      slot="tabContent"
      class="tab-pane col-md-11 col-lg-10 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="history"
      role="tabpanel"
      aria-labelledby="history-tab" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// /my-account/user-details
import tabLayout from '@/components/TabLayout'
import memberProfileDetails from '@/views/Members/Tabs/Details'
import memberProfileHistory from '@/views/Members/Tabs/MembershipHistory'
import GETSTORE from '@/store/memberProfileStore.js'

export default {
  name: 'MyMembershipDetails',
  props: ['details'],
  mixins: [GETSTORE],
  components: {
    'tab-layout': tabLayout,
    'member-profile-details': memberProfileDetails,
    'member-profile-history': memberProfileHistory
  },
  data() {
    return {
      child: this.details.parent_id !== null,
      selectedTab: 'details'
    }
  },
  methods: {
    renew() {
      this.$router.push({ name: 'My Profile', params: { renewing: true, tabSelect: 'membership', memberDetails: this.details, child: this.child } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/MyMembership/MyMembershipProfileChild.vue